import { render, staticRenderFns } from "./AboutComponent.vue?vue&type=template&id=7d11b1ba&scoped=true"
import script from "./AboutComponent.vue?vue&type=script&lang=js"
export * from "./AboutComponent.vue?vue&type=script&lang=js"
import style0 from "./AboutComponent.vue?vue&type=style&index=0&id=7d11b1ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d11b1ba",
  null
  
)

export default component.exports